import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';

export default function (query, lang) {
  const [allLanguages, setAllLanguages] = useState({});
  let url = '';
  if (query) {
    url = '/api/language/strings';
  }
  const { data, isRequestSuccessed } = useRequest({
    url: url,
    name: 'GET_LANGUAGES',
    manual: false,
  });

  useEffect(() => {
    if (data && JSON.stringify(data) !== '{}') {
      let languages_ = {};
      Object.keys(data).forEach(key => {
        if (!lang) {
          languages_[key] = data[key].value['en-US'];
        } else {
          Object.keys(data[key].value).forEach(lngType => {
            if (lang && lang === lngType) {
              languages_[key] = data[key].value[lngType];
            }
          });
        }
      });
      setAllLanguages(languages_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [allLanguages, isRequestSuccessed];
}
